//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useEffect, useCallback } from 'react';
//  Services
import BusinessHoursService from '../../API/Services/BusinessHoursService.js';
//  Context
import { useSession } from '../Context/SessionContext';
//  ----------      START   IMPORT  BLOCK       ----------

export const useUserMeBusinessHours = () => {
  const { isAuthenticated, user } = useSession();
  const [userData, setUserData] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [dataError, setDataError] = useState(null);
     
  const fetchUserBusinessHours = useCallback(async ()  => {

    const businessHoursService = new BusinessHoursService()
    const fetchedBusinessHours = await businessHoursService.readBusinessHours()
    return fetchedBusinessHours
  }, []);

  const updateBusinessHours = useCallback(async (new_schedule)  => {
    // If you need the hook to track loading, update the state here:
    // setIsDataLoading(true);
    // try {
        const businessHoursService = new BusinessHoursService()
        const updated_business_hours = await businessHoursService.updateBusinessHours(new_schedule);
        return updated_business_hours
    // } catch (error) { ... }
    // finally { setIsDataLoading(false); }
  }, []);



  useEffect(() => {
    if (!isAuthenticated || !user) {
      // Clear data if logged out or before user is loaded
      setUserData(null);
      return; 
    }

  // Dependency array ensures fetch runs when user is authenticated and the basic user object changes
  }, [isAuthenticated, user]); 

  // You can also add functions here like 'updateMyProfile'

  return { userData, isDataLoading, dataError, fetchUserBusinessHours, updateBusinessHours };
};